module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-container"
  }, [_c('div', {
    staticClass: "tag-group",
    style: (_vm.styleObj)
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "taglist-moving-animation"
    }
  }, _vm._l((_vm.openedTags), function(item, index) {
    return _c('Tag', {
      key: item.name,
      ref: item.name,
      refInFor: true,
      attrs: {
        "type": "dot",
        "name": item.name,
        "closable": item.name === 'admin' ? false : true,
        "color": item.name === _vm.currentTag ? 'blue' : 'default'
      },
      on: {
        "on-close": _vm.closeTag
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkTo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tag-list-drop"
  }, [_c('Dropdown', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "transfer": "",
      "trigger": "click",
      "placement": "bottom-start"
    },
    on: {
      "on-click": _vm.handleTagsOption
    }
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n          标签选项 "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "clearAll"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "clearOthers"
    }
  }, [_vm._v("关闭其他")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8cabc4de","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/admin-blocks/tag-lists.vue
// module id = e3Xd
// module chunks = 0